import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { Tooltip } from "primereact/tooltip";
import { useNavigate } from "react-router";
import "./CourseModal.scss";
import updateIconImg from "../../assets/updateIconImg.png";
import deleteIconImg from "../../assets/deleteIcon.png";
import addIcon from "../../assets/addWhiteIcon.png";
import Excalmation from "../../assets/Exclamation.png";
import ModalHeader from "../../components/Header/ModalHeader";
import DialogComponent from "../../components/Dialog";
import CourseForm from "./CourseCategoryForm";
import { getCoursesCategoryFromServer } from "../../services/CourseCategoryService";

function getUniqueValuesByKey(data, key) {
  const values = data.map((data) => data[key]);
  return [...new Set(values)];
}
function CourseCategoryView() {
  const [coursecategory, setCoursescategory] = useState([]);
  // const [dataitem, setDataitem] = useState([]); 
  const [categoryType, setCategoryType] = useState([]);
  const [uploadedDateTime, setUploadedDateTime] = useState([]);
  const [showAddCourseModal, setShowAddCourseModal] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [filters, setFilters] = useState({});
  const [selectedCoursescategory, setSelectedCoursescategory] = useState([]);
  const navigate = useNavigate();
  const toast = useRef(null);

  const fetchCoursecategories = async (page,pageSize) => {
    try {
      const result = await getCoursesCategoryFromServer(page,pageSize);
      const sorted = result.data.sort((a, b) => a.title.localeCompare(b.title));
      setCoursescategory(sorted);
      // setDataitem(sorted);
      setPage(result.page);
      setPageSize(result.pageSize);
      setTotalCount(result.total)
    } catch (error) {
      setCoursescategory([]);
      // setDataitem([]);
      // setPage(1);
      // setPageSize(10);
      setTotalCount(0)
      console.error("Error fetching course category :", error);
    }
  };
  useEffect(() => {
    fetchCoursecategories(page,pageSize);
  }, [page,pageSize]);
  useEffect(() => {
    setCategoryType(getUniqueValuesByKey(coursecategory, "categoryType"));
    setUploadedDateTime(getUniqueValuesByKey(coursecategory, "uploadedDateTime"));
  }, [coursecategory]);

  const handleModalClose = () => {
    setShowAddCourseModal(false);
    fetchCoursecategories(page,pageSize);
  };
  const handleAddCourseClick = () => {
    setShowAddCourseModal(true);
  };
  const onFilter = (e, field) => {
    const value = e.target.value.toLowerCase();
    const newFilters = { ...filters };
    newFilters[field] = value;
    setFilters(newFilters);
  };
  const searchTemplate = (field) => {
    const placeholderText = field.includes(".")
      ? `Search ${field
        .split(".")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")}`
      : `Search ${field}`;
    return (
      <InputText
        value={filters[field] || ""}
        onChange={(e) => onFilter(e, field)}
        placeholder={placeholderText}
        className="p-column-filter"
      />
    );
  };
  const filteredData = coursecategory.filter((item) =>
    Object.keys(filters).every((key) => {
      const keys = key.split(".");
      const value = keys.reduce((acc, k) => acc?.[k], item);
      return value?.toString().toLowerCase().includes(filters[key]);
    })
  );
  const handleTablePageChange = (newPage, newPageSize) => {
    setPage(newPage);
    setPageSize(newPageSize);
  };
  return (
    <>
      <Toast ref={toast} />
      <div className="masterScreen">
        <div className="grid flex justify-content-end mb-4" style={{ marginLeft: '49.5rem'}}>
          <div className="sm:col-12 md:col-6 button_section">
            <div className="flex justify-content-end align-items-center mt-4 mb-2 gap-18 w-full">
              <div className="grid flex justify-content-end mb-4">
                <div className="md:col-6 col-div"></div>
                <div className="sm:col-12 md:col-6 button_section">
                  <div className="flex justify-content-end align-items-center mb-2 gap-18 w-full">
                    <div className="flex gap-2">
                      <Button
                        className="master-updateBtn"
                        label="Update"
                        severity="info"
                        icon={<img src={updateIconImg} alt="Update icon" />}
                        outlined
                        disabled={selectedCoursescategory.length !== 1}
                        tooltip="Update Course Category"
                        tooltipOptions={{ position: "bottom", event: "both" }}
                        onClick={() => {
                          if (selectedCoursescategory.length === 1) {
                            const courseData = selectedCoursescategory[0];
                            navigate(`/coursecategory?tab=edit`, {
                              state: {
                                mode: "update",
                                course: courseData,
                              },
                            });
                            handleAddCourseClick();
                          }
                        }}
                      />
                      <Button
                        className="master-deleteBtn"
                        label="Delete"
                        severity="danger"
                        icon={<img src={deleteIconImg} alt="Delete icon" />}
                        outlined
                        disabled={selectedCoursescategory.length === 0}
                        // onClick={handleDeleteCourses}
                      />
                      <Button
                        className="addBtn"
                        label="Add Category"
                        icon={<img src={addIcon} alt="Add icon" />}
                        disabled={selectedCoursescategory.length > 0}
                        tooltip="Add Category"
                        tooltipOptions={{ position: "bottom", event: "both" }}
                        onClick={() => {
                          navigate("/coursecategory?tab=add");
                          handleAddCourseClick();
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <DataTable
          lazy
          className="table-viewport custom-tooltip"
          resizableColumns
          value={filteredData}
          size="small"
          dataKey="id"
          emptyMessage="No data found."
          filterDisplay="row"
          scrollable
          scrollHeight="700px"
          paginator
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="{first} to {last} of {totalRecords}"
          rows={pageSize}
          first={(page - 1) * pageSize}
          rowsPerPageOptions={[5, 10, 20, 50]} 
          onPage={(e) => {
            const newPage = Math.floor(e.first / e.rows) + 1;
            const newPageSize = e.rows;
            handleTablePageChange(newPage, newPageSize);
          }}
          totalRecords={totalCount}
          selection={selectedCoursescategory}
          onSelectionChange={(e) => setSelectedCoursescategory(e.value)}
        >
          <Column selectionMode="multiple" header="Select" frozen />
          <Column
            field="title"
            header="Course Category Title"
            filter
            showFilterMenu={false}
            filterPlaceholder="Search"
            filterElement={() => searchTemplate("title")}
          />
          <Column
            field="remarks"
            header="Course Category Description"
            filter
            showFilterMenu={false}
            filterPlaceholder="Search"
            filterElement={() => searchTemplate("title")}
          />
        </DataTable>
        <p className="text-sm">{totalCount} Total record</p>
      </div>
      <DialogComponent
        visible={showAddCourseModal}
        onHide={handleModalClose}
        header={<ModalHeader onClose={handleModalClose} backText="Back To Course Category" />}
        style={{ width: "100vw", maxWidth: "1000px", height: "100vh" }}
      >
        <CourseForm onClose={handleModalClose} onFormSubmit={() => setSelectedCoursescategory([])} />
      </DialogComponent>
      <ConfirmDialog />
    </>
  );
}

export default CourseCategoryView;